export default __webpack_public_path__ + "static/media/american-staffing-member.8a411f6f.png";